/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';

export default function PlusFeatureIcon({ size = 'xxsmall', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        // The star is not within the icon sizes we're using.
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
        color: '#f5a623',
      }}
      {...rest}
      viewBox="0 0 17 17"
    >
      <path
        fill="currentColor"
        d="M9 13.25L4.00382536 15.8766445 4.95800981 10.3133222 0.916019611 6.37335555 6.50191268 5.56167777 9 0.5 11.4980873 5.56167777 17.0839804 6.37335555 13.0419902 10.3133222 13.9961746 15.8766445z"
      ></path>
    </svg>
  );
}
